/**
 * Usersnap Widget ID Constants
 *
 * Each widget includes:
 * - id: The Usersnap widget ID
 * - internal: If true, only shown in non-production environments
 *
 * Usage remains the same - loadUsersnap automatically filters internal widgets in production:
 *
 * @example
 * import { loadUsersnap, USERSNAP_WIDGETS } from '@labxchange/util-usersnap';
 *
 * loadUsersnap(event, api, [
 *   USERSNAP_WIDGETS.SCROLLABLE_INTERNAL_FEEDBACK,  // Filtered out in production
 *   USERSNAP_WIDGETS.SCROLLABLE_USER_BUG_REPORT,    // Always shown
 *   USERSNAP_WIDGETS.SCROLLABLE_SATISFACTION_SCORE, // Always shown
 * ])
 */

export const USERSNAP_WIDGETS = {
  // Image Hotspots
  IMAGE_HOTSPOT_INTERNAL_FEEDBACK_STAGE: {
    id: "de895e29-d9b1-42f3-aeec-09ea84d7b0ab",
    internal: true,
  },
  IMAGE_HOTSPOT_USER_FEEDBACK_PROD: {
    id: "bb3e6367-6daa-47d1-bc63-58bc9d21fd50",
    internal: false,
  },
  IMAGE_HOTSPOT_SATISFACTION_SCORE: {
    id: "e3b4e5ec-f5f2-46d9-a06e-97464aebd319",
    internal: false,
  },

  // Scrollables
  SCROLLABLE_INTERNAL_FEEDBACK: {
    id: "dfc29538-2fe2-4cc6-b904-a5f6ce9744c9",
    internal: true,
  },
  SCROLLABLE_USER_BUG_REPORT: {
    id: "f8faf6fc-95cd-4c87-ad5d-58cf01fe4a33",
    internal: false,
  },
  SCROLLABLE_SATISFACTION_SCORE: {
    id: "1bc62b35-b089-4ae2-96e6-8fa9444a970c",
    internal: false,
  },

  // Simulations (Protocol, Hotspot, Spreadsheet, Frog)
  SIMULATION_INTERNAL_FEEDBACK: {
    id: "eaf78643-abc6-4245-bdc6-639f301b6e7c",
    internal: true,
  },
  SIMULATION_USER_BUG_REPORT: {
    id: "d8a3f2ea-88a7-41eb-a5e2-fe9235c810e5",
    internal: false,
  },
  SIMULATION_SATISFACTION_SCORE: {
    id: "daf36687-62ab-49d4-b0af-c017eb4c7e03",
    internal: false,
  },

  // Experimental Design Simulations
  EXPERIMENTAL_DESIGN_USER_BUG_REPORT: {
    id: "f37320ae-843f-4b08-bc33-87cfa01eac14",
    internal: false,
  },
  EXPERIMENTAL_DESIGN_INTERNAL_FEEDBACK: {
    id: "271e3308-c02f-4362-a42e-d023fb902ed0",
    internal: true,
  },
  EXPERIMENTAL_DESIGN_SATISFACTION_SCORE: {
    id: "daf36687-62ab-49d4-b0af-c017eb4c7e03",
    internal: false,
  },

  // Widgets (Slider widgets, etc.)
  WIDGET_INTERNAL_FEEDBACK: {
    id: "dfc29538-2fe2-4cc6-b904-a5f6ce9744c9",
    internal: true,
  },
  WIDGET_USER_BUG_REPORT: {
    id: "86d0e228-b94a-4065-9b55-d2f87bf026c5",
    internal: false,
  },

  // Career Explorer (API only - triggered manually, no button)
  CAREER_EXPLORER_SATISFACTION_SCORE: {
    id: "44830ef8-659a-4a8f-aae1-b545244e46f4",
    internal: false,
  },
};
